import {oauthApi, triggersApi} from './api';
import moment from 'moment';

export default {
  accountHasSalesforce() {
    return triggersApi.getJson(`/account/hasSalesforce`);
  },
  fetchCreatedDate() {
    return triggersApi.getJson(`/account/created_date`).then(moment);
  },
  hasSlack(): Promise<boolean> {
    return oauthApi.getJson(`/slack_enabled`);
  },
};
